import { createContext, ReactElement, useContext } from "react";
import GetMembrosBatizado, { ResponseMembrosCheckin } from "../services/getMembros";


export const MembroContext = createContext<ResponseMembrosCheckin>(null);


export const ProviderMembroBatismoContext = ({ children }: { children: ReactElement }) => {

  const services = GetMembrosBatizado()

  return (
    <>
    <MembroContext.Provider value={services}>
      {
        children
      }
    </MembroContext.Provider>
    </>
  )
}

export const useServicesMembroBatismo = () => {

  const context = useContext(MembroContext);

  return context
}
